<template>
  <div style="position: relative;">
    <IconButton
      :class="$style.button"
      :data-test-id="$testId('button')"
      hasNoBackground
      icon="support"
      text="Support"
      type="secondary"
      @click="handleSupportNavMenuItemClicked"
    />
  </div>
</template>

<script>
import { IconButton } from '@jumpcloud/ui-components';
import { mapMutations } from 'vuex';
import Util from 'client/util/Util';

export default {
  name: 'HeaderItemSupport',

  Util,

  components: {
    IconButton,
  },

  methods: {
    ...mapMutations('SupportModule', {
      setSupportOverlayOpen: 'SET_SUPPORT_OVERLAY_OPEN',
    }),

    handleSupportNavMenuItemClicked() {
      this.$emit('click');
      this.setSupportOverlayOpen(true);
    },
  },
};
</script>

<style scoped module>
.button {
  --icon-button-spacing: var(--jc-spacer-small);
}

.supportAnnouncement {
  position: absolute;
  right: -2rem;
  top: 4rem;
}
</style>
